import { getItemMaker } from "./tools";

const i = getItemMaker("statues");
export const statues = [
  i("Power Statue", "EquipmentStatues1"),
  i("Speed Statue", "EquipmentStatues2"),
  i("Mining Statue", "EquipmentStatues3"),
  i("Feasty Statue", "EquipmentStatues4"),
  i("Health Statue", "EquipmentStatues5"),
  i("Kachow Statue", "EquipmentStatues6"),
  i("Lumberbob Statue", "EquipmentStatues7"),
  i("Thicc Skin Statue", "EquipmentStatues8"),
  i("Oceanman Statue", "EquipmentStatues9"),
  i("Ol Reliable Statue", "EquipmentStatues10"),
  i("Exp Book Statue", "EquipmentStatues11"),
  i("Anvil Statue", "EquipmentStatues12"),
  i("Cauldron Statue", "EquipmentStatues13"),
  i("Beholder Statue", "EquipmentStatues14"),
  i("Bullseye Statue", "EquipmentStatues15"),
  i("Box Statue", "EquipmentStatues16"),
  i("Twosoul Statue", "EquipmentStatues17"),
  i("EhExPee Statue", "EquipmentStatues18"),
  i("Seesaw Statue", "EquipmentStatues19"),
  i("Pecunia Statue", "EquipmentStatues20"),
  i("Mutton Statue", "EquipmentStatues21"),
  i("Egg Statue", "EquipmentStatues22"),
  i("Battleaxe Statue", "EquipmentStatues23"),
  i("Spiral Statue", "EquipmentStatues24"),
  i("Boat Statue", "EquipmentStatues25"),
  i("Compost Statue", "EquipmentStatues26"),
  i("Stealth Statue", "EquipmentStatues27"),
  i("Essence Statue", "EquipmentStatues28"),
];
